import { clearBasket, updateItems } from "../redux/reducers/basket";
import store from "../redux/store";
import _ from "lodash";
import { DEFAULT_SERVICE_TYPES } from "./constants";
import dayjs from "dayjs";

export const getRestaurant = () => {
	return JSON.parse(localStorage.getItem("restaurant"));
};

export const getApplication = () => {
	return JSON.parse(localStorage.getItem("application"));
};

export const getServiceTypes = (res, app) => {
	const restaurant = getRestaurant();
	const application = getApplication();

	return application && application.serviceTypes
		? application.serviceTypes.split(",")
		: restaurant && restaurant.serviceTypes
		? restaurant.serviceTypes.split(",")
		: DEFAULT_SERVICE_TYPES;
};

export const checkBasket = () => {
	const basket = store.getState().basket;

	if (dayjs().diff(dayjs(basket.updatedAt), "hour") > 1) {
		store.dispatch(clearBasket());
	}
};

export const getTotalPrice = (basket, discountAmount = 0) => {
	let total = 0;
	if (basket.items.length > 0) {
		for (let product of basket.items) {
			total += (product.quantity || 1) * product.price;
		}

		if (basket.mode === "delivery") {
			total += parseFloat(basket.deliveryFees);
		}
	}
	return total - discountAmount;
};

export const getNumberProduct = (basket) => {
	let number = 0;
	for (let product of basket.items) {
		number += product.quantity;
	}
	return number;
};

export const getMenuTotalPrice = (menuPrice, orderMenuItems) => {
	let totalPrice = parseFloat(menuPrice);

	for (const [menuPartId, menuPartItems] of Object.entries(orderMenuItems)) {
		// const menuPart = menu.menuParts.find((elt) => elt.menuPartId == menuPartId);

		let nbItemsNoSupplementSelected = 0;
		menuPartItems
			.sort((a, b) => (a.price > b.price ? 1 : b.price > a.price ? -1 : 0))
			.forEach((product, index) => {
				if (product.supplement) {
					totalPrice += parseFloat(product.price) * product.quantity;
				} else {
					product.supplementAfterMax = 0;
					product.quantitySupplement = 0;
					for (let q = 0; q < product.quantity; q++) {
						nbItemsNoSupplementSelected += 1;
						if (
							product.supplementAfterMaxAllowed &&
							nbItemsNoSupplementSelected > product.itemsAllowed
						) {
							totalPrice += parseFloat(product.price);
							product.supplementAfterMax = 1;
							product.quantitySupplement += 1;
							//product.itemsAllowed = product.itemsAllowed;
						}
					}
				}
			});
	}

	return totalPrice;
};

export const getProductTotalPrice = (productPrice, product, options) => {
	let totalPrice = parseFloat(productPrice) * product.quantity;

	// let nbItemsNoSupplementSelected = 0;
	let totalOptionsPrice = 0;
	console.log({ options });
	if (options) {
		totalOptionsPrice = getOptionsTotalPrice(0, product.optionLists, options);

		totalPrice += totalOptionsPrice * product.quantity;

		// options
		// 	.sort((a, b) => (a.price > b.price ? 1 : b.price > a.price ? -1 : 0))
		// 	.forEach((opt, index) => {
		// 		if (opt.supplement) {
		// 			totalPrice += parseFloat(opt.price) * opt.quantity;
		// 		} else {
		// 			opt.supplementAfterMax = 0;
		// 			opt.quantitySupplement = 0;
		// 			for (let q = 0; q < opt.quantity; q++) {
		// 				nbItemsNoSupplementSelected += 1;
		// 				if (
		// 					product.supplementOptionAfterMaxAllowed &&
		// 					nbItemsNoSupplementSelected > product.nbOptionsAllowed
		// 				) {
		// 					totalPrice += parseFloat(opt.price);
		// 					opt.supplementAfterMax = 1;
		// 					opt.quantitySupplement += 1;
		// 					opt.nbOptionsAllowed = product.nbOptionsAllowed;
		// 				}
		// 			}
		// 		}
		// 	});
	}

	return totalPrice;
};

const getOptionsTotalPrice = (price, optionLists, selectedOptions) => {
	let totalOptionsPrice = parseFloat(price);

	for (const [optionListId, options] of Object.entries(selectedOptions)) {
		const optionList = optionLists.find(
			(elt) => elt.optionListId == optionListId
		);
		let nbItemsNoSupplementSelected = 0;
		if (options && Array.isArray(options)) {
			options
				.sort((a, b) => (a.price > b.price ? 1 : b.price > a.price ? -1 : 0))
				.forEach((opt, index) => {
					if (opt.supplement) {
						totalOptionsPrice += parseFloat(opt.price) * opt.quantity;
					} else {
						opt.supplementAfterMax = 0;
						opt.quantitySupplement = 0;
						for (let q = 0; q < opt.quantity; q++) {
							nbItemsNoSupplementSelected += 1;
							if (
								optionList.supplementAfterMaxAllowed &&
								nbItemsNoSupplementSelected > optionList.maxChoices
							) {
								totalOptionsPrice += parseFloat(opt.price);
								opt.supplementAfterMax = 1;
								opt.quantitySupplement += 1;
								opt.maxChoices = optionList.maxChoices;
								opt.minChoices = optionList.minChoices;
							}
						}
					}
				});
		}
	}

	console.log({ totalOptionsPrice });
	return totalOptionsPrice;
};

export const checkItemAvailabilityChangeBasketMode = (mode) => {
	const basket = store.getState().basket;

	if (
		basket.mode != mode &&
		basket.items.some(
			(it) => it.servicesAvailability && !it.servicesAvailability.includes(mode)
		)
	) {
		return true;
	}
	return false;
};

export const updateBasket = (mode) => {
	const basket = store.getState().basket;
	const items = basket.items
		.filter(
			(it) => !it.servicesAvailability || it.servicesAvailability.includes(mode)
		)
		.map((item) => {
			let nItem = { ...item };
			let itemPrice = null;
			if (mode === "delivery" && item.priceDelivery) {
				itemPrice = item.priceDelivery;
			} else if (mode === "takeAway" && item.priceTakeAway) {
				itemPrice = item.priceTakeAway;
			} else {
				if (item.menuId) {
					itemPrice = item.menuPrice;
				} else {
					itemPrice = item.productPrice;
				}
			}

			if (item.menuId) {
				nItem.basePrice = getMenuTotalPrice(
					itemPrice,
					_.cloneDeep(item.content)
				);
			} else {
				nItem.basePrice = getProductTotalPrice(
					itemPrice,
					nItem,
					_.cloneDeep(item.content)
				);
			}

			nItem.price = parseFloat(nItem.basePrice) - (nItem.discountAmount || 0);

			return nItem;
		});

	store.dispatch(
		updateItems({
			items,
		})
	);
};
